export const getExperimentBucket = (
  experimentId: number,
): { id: string } | undefined => {
  const variationMap = window.optimizely?.get('state')?.getVariationMap()
  return variationMap?.[experimentId]
}
